import { createReducer, on } from '@ngrx/store';
import { MyContentsState } from '@app/selectors/system/my-contents.selector';
import { MyContentsModel } from '@app/models/system/my-contents.model';
import { loadContentsSuccess } from '@app/actions/system/my-contents.actions';

export const contentsFeatureKey = 'contents';

export const initialContents : MyContentsState = {
    contents: [] as MyContentsModel[]
};

export const contentsReducer = createReducer(
    initialContents,
    on( loadContentsSuccess, (state, { contents }) => ({
        ...state,
        contents,
    }))
);